import config from "../../../../../components/interop/config";
import urls from "../../../../../components/interop/urls";
import { ImagePreview } from "../../images/ImagePreview";

const localeDomain = {
  'es': 'opinautos-images',
  'pt': 'opicarros-images',
  'en': 'startmycar-images',
}

export default function PublishedFuseboxThumbnail({ context, locale = 'es', boxIndex = 0 }) {
  let {modelId, year, ... other} = context || {};
  let [marca, ... modeloParts] = modelId.split('-');

  let marcaUrlSafe = marca.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replaceAll(' ', '-');
  let modeloUrlSafe = modeloParts.join('-').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
  .replaceAll(' ', '-')
  .replace(new RegExp("[^\\w-\\s]", 'g'), "");
  
  // TODO: Hardcodeada para no meter model renames por locale acá
  if(locale === 'es') {  
    modeloUrlSafe = modeloUrlSafe.replace(/^(\w)-class/, 'clase-$1');
    modeloUrlSafe = modeloUrlSafe.replace(/^(\w+)-series/, 'serie-$1');
  }
  
  let modelo = {idModelo: modelId, marcaUrlSafe, modeloUrlSafe};
  let url = urls.urlFuseboxThumbnail(modelo, year, other, boxIndex);
  

  url = url.replace(`${config.s3FuseboxImageBucket}`, localeDomain[locale])

  return <ImagePreview className={'border border-primary bg-light-primary rounded p-1 mr-1'} url={url} img100 zoom={true} />
}